import './Footer.css'

const Footer = () => (
  <footer>
    <a href='https://github.com/kimman8' className='link'>
      &copy;Kim Yuen {new Date().getFullYear()}{' '}
    </a>
  </footer>
)

export default Footer
